import ProjectView from "../../project-view"
import ProjectViews from "../../project-views"
import {ProjectView_Todos_AccessControl} from "./acl"
import {ProjectViewConfig} from "../../@types";

export default class ProjectView_Todos extends ProjectView {

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)
    }

    get acl():ProjectView_Todos_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Todos_AccessControl(this)
        }

        return this._acl
    }
}
